<template>
	<Dropdown
		:options="options"
		:scrollable="false"
		pill
		small
		hideCaret
		v-model="sortOrder"
		class="search-sort-dropdown"
	>
		<template v-slot="{ option }">
			<div class="search-sort-option">
				{{ $t(`search_sort_type_${option.trans}`) }}
				<CheckIcon
					class="checkmark-icon"
					type="solid"
					v-if="option.id === model"
				/>
			</div>
		</template>
		<template #selected="{ option }">
			<div class="selected-option">
				<BarsSort type="solid" class="filter-icon" />
				{{ $t(`search_sort_type_${option.trans}`) }}
			</div>
		</template>
	</Dropdown>
</template>

<script setup>
import { ref, watch } from 'vue'
import { BarsSort, CheckIcon } from '@/icons'
import { Dropdown } from '@/components/common'
import { sortTypes } from '@/helpers/constants'

const options = [
	{ id: sortTypes.NEWEST, trans: 'newest' },
	{ id: sortTypes.OLDEST, trans: 'oldest' },
	{ id: sortTypes.RELEVANCE, trans: 'relevant' },
]

const model = defineModel({ default: sortTypes.NEWEST })
const sortOrder = ref(model.value)

watch(sortOrder, (val) => {
	model.value = val
})
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.search-sort-dropdown {
	width: auto;
	:deep(.dropdown-selected) {
		width: calc(max-content + 16px);
		background: var(--neutral-0);
	}
	:deep(.dropdown-options-container) {
		min-width: max-content;
		margin-top: 8px;
		.dropdown-option {
			white-space: nowrap;
		}
	}
	.selected-option {
		@include flex(8px);
		.pronto-icon {
			font-size: 16px;
			color: var(--blue-300);
		}
	}
	.search-sort-option {
		min-width: 120px;
		@include flex-spread;
		font-size: 14px;
		@include fontFamily(400);
		.pronto-icon {
			color: var(--blue-300);
		}
	}
}
</style>

<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.search-sort-dropdown {
		.dropdown-options-container {
			.dropdown-options {
				background: var(--neutral-200) !important;
			}
		}
	}
}
</style>
